import { store } from "./../redux/reducers";
import { RETIRE_AGE, LIFE_EXP, CONTRIBUTION, CURRENT_AGE, EXPENSES, } from "../constants/sliderConstants";
import { get_future_expense_planner } from "../redux";
import moment from "moment";
import { inflation } from "../constants";
export const getDate = () => new Date();
export const getBirthYear = (dob) => parseInt(dob.split("-")[0], 10);
export const getYearMoment = (val) => +moment(val).format("YYYY");
export const getCurrentAge = (dob) => {
    return moment().diff(dob, "years");
};
// Slider options object intialiser helper
const getConfig = (title, min, max, type) => ({
    title,
    min,
    max,
    type,
});
// Create the slider options config object
export const getEditAssumptionsInitialState = async (token, userData) => {
    // If user is logged in we try to get his user data for else set default values
    const dob = userData?.dob || "1993-01-01";
    const current_age = getCurrentAge(dob);
    const retireValue = userData?.retireAge || RETIRE_AGE.VALUE;
    const lifeExpectancy = userData?.lifeExpectancy || LIFE_EXP.VALUE;
    const contri = userData?.annualContribution || CONTRIBUTION.VALUE;
    // Later get from backend because unnecssary api call
    const futureExpense = token && userData?.isLinked
        ? (await getFutureExpense(getYearMoment(dob) + retireValue)) ||
            userData?.futureExpense ||
            EXPENSES.VALUE
        : EXPENSES.VALUE;
    const { socialSecurity } = token && userData
        ? (await store.dispatch(get_future_expense_planner(getYearMoment(dob) + retireValue + ""))) || { socialSecurity: [] }
        : { socialSecurity: [] };
    // const futureExpense = userData?.futureExpense || ;
    const openingBalance = userData?.approx_401k_balance || 1000;
    const strategyIndex = userData?.strategy || 0;
    const retireAge = {
        config: getConfig(RETIRE_AGE.TITLE, current_age + 1, RETIRE_AGE.MAX, RETIRE_AGE.TYPE),
        value: retireValue,
    };
    const lifeExp = {
        config: getConfig(LIFE_EXP.TITLE, retireValue + 1, LIFE_EXP.MAX, LIFE_EXP.TYPE),
        value: lifeExpectancy,
    };
    const contribution = {
        config: getConfig(...Object.values(CONTRIBUTION)),
        value: contri,
    };
    const currentAge = {
        config: getConfig(...Object.values(CURRENT_AGE)),
        value: current_age,
    };
    const expenses = {
        config: getConfig(...Object.values(EXPENSES)),
        value: futureExpense,
    };
    let slider_options = {
        ...(token && userData?.dob ? {} : { currentAge }),
        retireAge,
        lifeExp,
        contribution,
        ...(token && userData?.isLinked ? {} : { expenses }),
    };
    return {
        sliderOptions: slider_options,
        openingBalance,
        strategyIndex,
        expense_home: futureExpense,
        socialSecurity,
    };
};
export const getFutureExpense = async (fromYear) => {
    const { futureExpenses } = await store.dispatch(get_future_expense_planner(fromYear));
    let expenses = 0;
    futureExpenses?.map((item) => {
        if (item.category === "Social Security") {
            return null;
        }
        else {
            expenses += item.future ? +item.future : 0;
        }
    });
    return expenses * inflation ** (+fromYear - +moment().format("YYYY"));
};
// Search accord data
export const searchData = (data, key, value, index, dataParam) => {
    const regex = new RegExp(`^${value}|${value}`, "i");
    if (index) {
        return data.filter((x) => regex.test(x[key]));
    }
    const filteredData = [];
    let flag = false;
    for (let i = 0; i < data.length; i += 1) {
        const temp = data[i][dataParam ? dataParam : "list"].filter((item) => regex.test(item[key]));
        const dataItem = { ...data[i] };
        dataItem[dataParam ? dataParam : "list"] = temp;
        if (temp.length) {
            if (!flag) {
                dataItem.selected = true;
            }
            filteredData.push(dataItem);
            flag = true;
        }
    }
    return filteredData;
};
function compare(a, b, prop, process, order) {
    if (process(a[prop]) < process(b[prop])) {
        return 1 * order;
    }
    if (process(a[prop]) > process(b[prop])) {
        return -1 * order;
    }
    return 0;
}
// Convert to Date from string
export const processTime = (x) => {
    const a = x.split(" ");
    const d = a[0].split("-");
    let t;
    if (a[1]) {
        t = a[1].split(":");
    }
    return t
        ? new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2])
        : new Date(d[0], d[1] - 1, d[2]);
};
// Sort accord data
export const sortData = (data, type, propArray) => {
    switch (type) {
        case 0: {
            // Sort acsending value wise
            return data.sort((a, b) => compare(a, b, propArray[type], (x) => parseFloat(x), 1));
        }
        case 1: {
            // Sort desending value wise
            return data.sort((a, b) => compare(a, b, propArray[type], (x) => parseFloat(x), -1));
        }
        case 2: {
            // Sort acsending time wise
            return data.sort((a, b) => compare(a, b, propArray[type], (x) => processTime(x), 1));
        }
        case 3: {
            // Sort desending time wise
            return data.sort((a, b) => compare(a, b, propArray[type], (x) => processTime(x), -1));
        }
        default:
            return data;
    }
};
export const getThumbsUpTitle = (type) => {
    switch (type) {
        case "contribution":
            return "Annual Contribution";
        case "retireAge":
            return "Retirement Age";
        case "strategy":
            return "Investment Strategy";
    }
};
